import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/engineer',
    children: [
      { path: '', redirect: '/engineer/home' },
      { path: 'home', name: 'engineer-home', component: () => import('@/modules/engineer/EngineerHome.vue') },
      { path: 'bom', name: 'engineer-bom', component: () => import('@/modules/engineer/BomTreeEditor.vue') },
      { path: 'bom-tree', name: 'engineer-bom-tree', component: () => import('@/modules/engineer/BomTreeEditor.vue') },
      { path: 'process', name: 'engineer-process', component: () => import('@/modules/engineer/ProcessRouting.vue') },
      { path: 'recipe', name: 'engineer-recipe', component: () => import('@/modules/engineer/CorrugatedRecipeList.vue') },
      { path: 'recipes', name: 'engineer-recipes', component: () => import('@/modules/engineer/CorrugatedRecipeList.vue') },
      { path: 'product', name: 'engineer-product', component: () => import('@/modules/engineer/ProductManage.vue') },
      { path: 'products', name: 'engineer-products', component: () => import('@/modules/engineer/ProductManage.vue') },
      { path: 'product-new', name: 'engineer-product-new', component: () => import('@/modules/engineer/ProductManage.vue') }
    ]
  }
]

export default routes
